module.exports = __webpack_public_path__ + "static/media/python_logo.6439030d.png";